import { Component, OnInit } from '@angular/core';
import {
  Router,
  NavigationEnd,
  NavigationStart,
  NavigationCancel,
  NavigationError,
  Event,
  ActivatedRoute,
} from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { map, filter, mergeMap } from 'rxjs/operators';
declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  loading: boolean;
  contraste: boolean;
  fragment: any;
  queryParams: any;

  // Utilizado na consulta pública
  // isCnct: boolean = false;
  // isCatalogos: boolean = false;

  constructor(
    private router: Router,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private metaService: Meta,
  ) {
    // passive listener para melhorar o scroll
    document.addEventListener('touchstart', () => { }, { passive: true });
    router.events.subscribe((routerEvent: Event) => {
      this.verificaEventoDaRota(routerEvent);
    });
    // conexão google analytics
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        gtag('config', 'G-Z1FMVRGLJ0', {
          page_path: event.urlAfterRedirects,
        });
      });
  }

  ngOnInit() {
    if (localStorage.getItem('altoContraste') === 'true') {
      this.contraste = true;
    }

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          return this.activatedRoute;
        }),
        map((route) => {
          while (route.firstChild) { route = route.firstChild; }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => {
          return route.data;
        }),
      )
      .subscribe((event) => {
        this.titleService.setTitle(this.criaTitulo(event));
      });

    this.metaService.addTags([
      { name: 'keywords', content: 'CNCST, Catalogo, Cursos Superiores de Tecnologia' },
      { name: 'description', content: 'Catálogo Nacional de Cursos Superiores de Tecnologia' },
      { name: 'robots', content: 'index' },
    ]);
  }

  criaTitulo(event: any): string {
    if (event.title) {
      if (event.title.startsWith('{{')) {
        const [key, value] = event.title.replace('{{', '').replace('}}', '').split('.');
        return `${event[key][value]} | CNCST`;
      }
      return `${event.title} | CNCST`;
    }
  }

  // Gera o spinner enquanto os dados estão sendo carregados na página.
  // Caso loading (carregando) for verdade o spinner irá aparecer na tela.
  verificaEventoDaRota(routerEvent: Event): void {
    if (routerEvent instanceof NavigationStart) {
      this.loading = true;
    }
    if (
      routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError
    ) {
      setTimeout(() => {
        this.loading = false;
      }, 700);
    }

    // Utilizado na consulta pública

    // if (window.location.pathname === '/envie-sugestao-cnct' ||
    //     window.location.pathname === '/cncst/envie-sugestao-cnct' ||
    //     window.location.pathname === '/cncst/aviso-sugestao-cnct' ||
    //     window.location.pathname === '/aviso-sugestao-cnct'){
    //   this.isCnct = true;
    //   this.isCatalogos = false;
    // }
    // else if (window.location.pathname === '/envie-sugestao-areas' ||
    //         window.location.pathname === '/cncst/envie-sugestao-areas' ||
    //         window.location.pathname === '/cncst/aviso-sugestao-areas' ||
    //         window.location.pathname === '/aviso-sugestao-areas'){
    //   this.isCatalogos = true;
    //   this.isCnct = false;
    // }

    // else {
    //   this.isCnct = false;
    //   this.isCatalogos = false;
    // }
  }

  altoContraste(event: boolean) {
    this.contraste = event;
    localStorage.setItem('altoContraste', this.contraste.toString());
  }
}
